import { getSessionUser } from "./session";

export const isAdvancedUser = () => {
  const session = getSessionUser();

  return session?.type === "root";
};

export const canManageStores = (userData = getSessionUser()) =>
  Boolean(userData?.is_mix);
